/** Brand mark: Merah Putih split square. */
export function Mark({ size = 28, onDark = false }: { size?: number; onDark?: boolean }) {
  return (
    <span className={`mark ${onDark ? 'on-dark' : ''}`} style={{ width: size, height: size }} aria-hidden="true">
      <span />
      <span />
    </span>
  );
}
